// extracted by mini-css-extract-plugin
export default {"mainFieldContainer":"DesignationAgreementPage_mainFieldContainer__+bBPm","adminIconArea":"DesignationAgreementPage_adminIconArea__0Wpsw"};